import { render, staticRenderFns } from "./RolesManagement.vue?vue&type=template&id=bf5006f6"
import script from "./RolesManagement.vue?vue&type=script&lang=js"
export * from "./RolesManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports